(function () {
  "use strict";

  angular.module("sempraWebapp").component("holidays", {
    templateUrl: "app/workingSchedulesAndHolidays/holidays/holidays.html",
    controller: holidays,
    bindings: {
      holidaysData: "<",
      siteId: "<",
      activeForm: "<",
      refresh: "&"
    },
    controllerAs: "vm"
  });

  function holidays(
    $mdDialog,
    $translate,
    layoutActions,
    workingSchedulesActions,
    $scope
  ) {
    var vm = this,
      editMode = false,
      holidayId = null;

    vm.holidayList = [];

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.holidaysData) {
        vm.holidayList = changes.holidaysData.currentValue;
      } else if (changes.siteId) {
        vm.siteId = changes.siteId.currentValue;
      }
    };

    vm.updateHoliday = function (holiday) {
      editMode = true;
      holidayId = holiday.id;
      vm.holidatDate = holiday.date;
      vm.holidayDescription = holiday.description;
      vm.holidayFixed = holiday.fixed;
      vm.holidayYear = holiday.year;
    };

    vm.resetHolidayInputs = function (form) {
      clearAllHolidaysInputs(form);
    };

    vm.resetYearInput = function() {
      vm.holidayYear = '';
    }

    vm.deleteHoliday = function (ev, holiday) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translate.instant("DELETE_HOLIDAY") +
            $translate.instant("FOR_DATE") +
            holiday.date +
            $translate.instant("WITH_ID") +
            holiday.id
        )
        .textContent($translate.instant("ARE_YOU_SURE"))
        .ariaLabel("Delete holiday")
        .targetEvent(ev)
        .ok($translate.instant("YES"))
        .cancel($translate.instant("CANCEL"));

      $mdDialog.show(confirm).then(
        function () {
          layoutActions.showLoader();
          workingSchedulesActions
            .deleteHoliday(vm.siteId, holiday.id)
            .then(function () {
              vm.refresh();
              // refreshHolidayList();
            });
        },
        function () {}
      );
    };

    vm.saveHolidays = function () {
      var dataToSave = {
        siteHolidayDtoList: [
          {
            id: editMode ? holidayId : null,
            date: vm.holidatDate,
            description: vm.holidayDescription,
            fixed: vm.holidayFixed,
            year: vm.holidayYear ? vm.holidayYear : "",
            yearPresent: true
          }
        ]
      };

      if (editMode) {
        workingSchedulesActions
          .updateSiteHolidays(vm.siteId, dataToSave)
          .then(function () {
            vm.refresh();
          });
      } else {
        workingSchedulesActions
          .createSiteHolidays(vm.siteId, dataToSave)
          .then(function () {
            vm.refresh();
            // refreshHolidayList();
            clearAllHolidaysInputs($scope.siteHolidaysForm);
          });
      }
    };

    vm.deleteAllHolidays = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant("DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE"))
        .textContent($translate.instant("ARE_YOU_SURE"))
        .ariaLabel("Delete all holidays")
        .targetEvent(ev)
        .ok($translate.instant("YES"))
        .cancel($translate.instant("CANCEL"));

      $mdDialog.show(confirm).then(
        function () {
          layoutActions.showLoader();
          workingSchedulesActions
            .deleteSiteHolidays(vm.siteId)
            .then(function () {
              vm.refresh();
              clearAllHolidaysInputs($scope.siteHolidaysForm);
              layoutActions.hideLoader();
            });
        },
        function () {}
      );
    };

    function clearAllHolidaysInputs(form) {
      editMode = false;
      vm.holidatDate = "";
      vm.holidayDescription = "";
      vm.holidayFixed = "";
      vm.holidayYear = "";
      form.$setPristine();
      form.$setUntouched();
    }
  }
})();
